import { EditProductParams } from 'types/services';
import { m8API } from 'services/production/m8';
import { M8ProductType } from '../types';

export const editProduct = async (params: EditProductParams): Promise<void> => {
  const { product, formValues } = params;

  await m8API.admin.updateCalculationComponent({
    type: product.type,
    defaultCountValue: Number(formValues.defaultAmount),
    name: formValues.name,
  });

  const productType = product.type as M8ProductType;

  await m8API.admin.setDefaultPartnerComissionFor({
    productType,
    comission: Number(formValues.defaultPartnerComission),
  });
};
